import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_EMBEDDED = "/embedded";

export const PATH_EMBEDDED_ONBOARDING = `${PATH_EMBEDDED}/onboarding`;
export const PATH_EMBEDDED_DEFAULT_PAYMENT_METHOD = `${PATH_EMBEDDED}/default-payment-method`;
export const PATH_EMBEDDED_DEFAULT_PAYOUT_METHOD = `${PATH_EMBEDDED}/default-payout-method`;

export const PARAMETER_REQUIREMENT_ID = "requirementId";

export const PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS = `${PATH_EMBEDDED_ONBOARDING}/eligibility-requirements/:${PARAMETER_REQUIREMENT_ID}`;

export const routeHelpersEmbeddedOnboardingRequirementDetails =
  createRouteHelpers(PATH_EMBEDDED_ONBOARDING_REQUIREMENT_DETAILS);
